<template>
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        :required="required"
        :minlength="minlength"
        :maxlength="maxlength"
        :validations="validations"
    >
        <template #label>
            <slot name="label">{{ $attrs.label }}</slot>
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>
<script>
    import { validEmail } from "@/util/validation"
    import FieldProxyMixin from "@/components/form/FieldProxyMixin"

    export default {
        mixins: [FieldProxyMixin],

        props: {
            minlength: {
                type: [Number, String],
                default: null,
            },

            maxlength: {
                type: [Number, String],
                default: null,
            },
        },

        methods: {
            validationSource: function (target, field) {
                field.applyValidator(target, validEmail.id, validEmail)
            },
        },
    }
</script>

<style lang="scss">
    .v-messages__message {
        line-height: 16px !important;
    }
</style>
